import { ReactComponent as Arrowhead } from "../assets/icons/arrowhead.svg";
import { ReactComponent as ArrowheadLinearGradient } from "../assets/icons/arrowhead-linear-gradient.svg";
import { ReactComponent as Assets } from "../assets/icons/assets.svg";
import { ReactComponent as Authentication } from "../assets/icons/authentication.svg";
import { ReactComponent as Bin } from "../assets/icons/bin.svg";
import { ReactComponent as BronzeBadge } from "../assets/icons/bronze-badge.svg";
import { ReactComponent as Calendar } from "../assets/icons/calendar.svg";
import { ReactComponent as Clock } from "../assets/icons/clock.svg";
import { ReactComponent as ClosedTicket } from "../assets/icons/closed-ticket.svg";
import { ReactComponent as Copy } from "../assets/icons/copy.svg";
import { ReactComponent as Cross } from "../assets/icons/cross.svg";
import { ReactComponent as Dashboard } from "../assets/icons/dashboard.svg";
import { ReactComponent as Deposit } from "../assets/icons/deposit.svg";
import { ReactComponent as Diamond } from "../assets/icons/diamond.svg";
import { ReactComponent as Dislike} from "../assets/icons/dislike.svg";
import { ReactComponent as Envelope } from "../assets/icons/envelope.svg";
import { ReactComponent as Exchange } from "../assets/icons/exchange.svg";
import { ReactComponent as GoldenBadge } from "../assets/icons/golden-badge.svg";
import { ReactComponent as History } from "../assets/icons/history.svg";
import { ReactComponent as Instagram } from "../assets/icons/instagram.svg";
import { ReactComponent as InviteFriends } from "../assets/icons/invite-friends.svg";
import { ReactComponent as InputVisible } from "../assets/icons/input-visible.svg";
import { ReactComponent as InputInvisible } from "../assets/icons/input-invisible.svg";
import { ReactComponent as InsufficientStock } from "../assets/icons/insufficient-stock.svg";
import { ReactComponent as Like } from "../assets/icons/like.svg";
import { ReactComponent as LocationPin } from "../assets/icons/location-pin.svg";
import { ReactComponent as Logout } from "../assets/icons/logout.svg";
import { ReactComponent as MessagePlaneBlack } from "../assets/icons/message-plane-black.svg";
import { ReactComponent as MessagePlaneGolden } from "../assets/icons/message-plane-golden.svg";
import { ReactComponent as Notifications } from "../assets/icons/notifications.svg";
import { ReactComponent as P2P } from "../assets/icons/p2p.svg";
import { ReactComponent as Plus } from "../assets/icons/plus.svg";
import { ReactComponent as Plus2 } from "../assets/icons/plus-2.svg";
import { ReactComponent as Rank } from "../assets/icons/rank.svg";
import { ReactComponent as ReplyGolden } from "../assets/icons/reply-golden.svg";
import { ReactComponent as ReplyNormal } from "../assets/icons/reply-normal.svg";
import { ReactComponent as SentTicket } from "../assets/icons/sent-ticket.svg";
import { ReactComponent as Settings } from "../assets/icons/settings.svg";
import { ReactComponent as SilverBadge } from "../assets/icons/silver-badge.svg";
import { ReactComponent as SlideMenu } from "../assets/icons/slide-menu.svg";
import { ReactComponent as SufficientStock } from "../assets/icons/sufficient-stock.svg";
import { ReactComponent as Support } from "../assets/icons/support.svg";
import { ReactComponent as Telegram } from "../assets/icons/telegram.svg";
import { ReactComponent as Telephone } from "../assets/icons/telephone.svg";
import { ReactComponent as Tick } from "../assets/icons/tick.svg";
import { ReactComponent as Twitter } from "../assets/icons/twitter.svg";
import { ReactComponent as Upload } from "../assets/icons/upload.svg";
import { ReactComponent as User } from "../assets/icons/user.svg";
import { ReactComponent as Withdraw } from "../assets/icons/withdraw.svg";
import { ReactComponent as WhatsApp } from "../assets/icons/whatsApp.svg";

const icons = {
  arrowhead: <Arrowhead />,
  arrowheadLinearGradient: <ArrowheadLinearGradient />,
  assets: <Assets />,
  authentication: <Authentication />,
  bin: <Bin />,
  bronzeBadge: <BronzeBadge />,
  calendar: <Calendar />,
  clock: <Clock />,
  closedTicket: <ClosedTicket />,
  copy: <Copy />,
  cross: <Cross />,
  dashboard: <Dashboard />,
  deposit: <Deposit />,
  diamond: <Diamond />,
  dislike: <Dislike />,
  envelope: <Envelope />,
  exchange: <Exchange />,
  goldenBadge: <GoldenBadge />,
  history: <History />,
  instagram: <Instagram />,
  inviteFriends: <InviteFriends />,
  inputVisible: <InputVisible />,
  inputInvisible: <InputInvisible />,
  insufficientStock: <InsufficientStock />,
  like: <Like />,
  locationPin: <LocationPin />,
  logout: <Logout />,
  messagePlaneBlack: <MessagePlaneBlack />,
  messagePlaneGolden: <MessagePlaneGolden />,
  notifications: <Notifications />,
  p2p: <P2P />,
  plus: <Plus />,
  plus2: <Plus2 />,
  rank: <Rank />,
  replyGolden: <ReplyGolden />,
  replyNormal: <ReplyNormal />,
  sentTicket: <SentTicket />,
  settings: <Settings />,
  silverBadge: <SilverBadge />,
  slideMenu: <SlideMenu />,
  sufficientStock: <SufficientStock />,
  support: <Support />,
  telegram: <Telegram />,
  telephone: <Telephone />,
  tick: <Tick />,
  twitter: <Twitter />,
  upload: <Upload />,
  user: <User />,
  whatsApp: <WhatsApp />,
  withdraw: <Withdraw />,
};

export default icons;
